var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.104,
    height: 12.8,
    viewBox: "0 0 18.104 12.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-mail",
    "data-name": "Icon feather-mail",
    transform: "translate(-2.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_37990",
    "data-name": "Path 37990",
    transform: "translate(0 -6)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8,6H19.2A1.714,1.714,0,0,1,21,7.6v9.6a1.714,1.714,0,0,1-1.8,1.6H4.8A1.714,1.714,0,0,1,3,17.2V7.6A1.714,1.714,0,0,1,4.8,6Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.799999237060547 7.5 C 4.628337860107422 7.5 4.525905609130859 7.580598831176758 4.5 7.617847442626953 L 4.5 17.18215370178223 C 4.525905609130859 17.21940231323242 4.628337860107422 17.30000114440918 4.799999237060547 17.30000114440918 L 19.20000076293945 17.30000114440918 C 19.37166213989258 17.30000114440918 19.47409439086914 17.21940231323242 19.5 17.18215370178223 L 19.5 7.617847442626953 C 19.47409439086914 7.580598831176758 19.37166213989258 7.5 19.20000076293945 7.5 L 4.799999237060547 7.5 M 4.799999237060547 6 L 19.20000076293945 6 C 20.19000053405762 6 21 6.720001220703125 21 7.600000381469727 L 21 17.20000076293945 C 21 18.07999992370605 20.19000053405762 18.80000114440918 19.20000076293945 18.80000114440918 L 4.799999237060547 18.80000114440918 C 3.809999465942383 18.80000114440918 3 18.07999992370605 3 17.20000076293945 L 3 7.600000381469727 C 3 6.720001220703125 3.809999465942383 6 4.799999237060547 6 Z",
    stroke: "none",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37991",
    "data-name": "Path 37991",
    d: "M19.015,9l-8.007,5.6L3,9",
    transform: "translate(1.024 -7.4)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.49f247ff238b9a17ea16edc8b2dc4f4e.svg";
export { ForwardRef as ReactComponent };